import { Grid } from '@material-ui/core';
import { ImagePreview, PdfPreview, helpers } from 'design-system';

// Helpers
const { isImage, isPdf } = helpers;

type Props = {
  base64String: string;
  fileName: string;
  fileId: string;
  requestStatus: string;
  disabled?: boolean;
  deleteButtonId?: string;
  onDelete: (id: string) => void;
};

const FilePresenter = ({
  base64String,
  fileName,
  requestStatus,
  disabled,
  deleteButtonId,
  onDelete,
  fileId,
}: Props): JSX.Element => {
  const hasImageMime = isImage(base64String);
  const hasPdfMime = isPdf(base64String);

  return (
    <Grid container alignItems="center" justifyContent="center">
      {hasImageMime ? (
        <ImagePreview
          data-testid="photo-container"
          imageBase64={base64String}
          onDelete={(): void => onDelete(fileId)}
          deleteButtonId={deleteButtonId}
          disabled={disabled}
          requestStatus={requestStatus}
        />
      ) : (
        hasPdfMime && (
          <PdfPreview
            data-testid="pdf-container"
            displayValue={fileName}
            onDelete={(): void => onDelete(fileId)}
            deleteButtonId={deleteButtonId}
            disabled={disabled}
            requestStatus={requestStatus}
          />
        )
      )}
    </Grid>
  );
};

export default FilePresenter;
